/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Harden_Detail6Inputs */

const en_svc_retainer_harden_detail6 = /** @type {(inputs: Svc_Retainer_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updates, audits and a report at the end of each month.`)
};

const ar_svc_retainer_harden_detail6 = /** @type {(inputs: Svc_Retainer_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحديثات والتدقيق وتقرير في نهاية كل شهر.`)
};

const bn_svc_retainer_harden_detail6 = /** @type {(inputs: Svc_Retainer_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপডেট, অডিট আর প্রতি মাসের শেষে রিপোর্ট।`)
};

const de_svc_retainer_harden_detail6 = /** @type {(inputs: Svc_Retainer_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updates, Audits und ein Bericht am Ende jedes Monats.`)
};

const es_svc_retainer_harden_detail6 = /** @type {(inputs: Svc_Retainer_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizaciones, auditorías e informe al final de cada mes.`)
};

const fr_svc_retainer_harden_detail6 = /** @type {(inputs: Svc_Retainer_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mises à jour, audits et rapport à la fin de chaque mois.`)
};

const pt_svc_retainer_harden_detail6 = /** @type {(inputs: Svc_Retainer_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizações, auditorias e relatório no fim de cada mês.`)
};

const zh_svc_retainer_harden_detail6 = /** @type {(inputs: Svc_Retainer_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新、审计，每月月底一份报告。`)
};

const tr_svc_retainer_harden_detail6 = /** @type {(inputs: Svc_Retainer_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her ay sonunda güncellemeler, denetimler ve rapor.`)
};

const ru_svc_retainer_harden_detail6 = /** @type {(inputs: Svc_Retainer_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновления, аудиты и отчёт в конце каждого месяца.`)
};

const pl_svc_retainer_harden_detail6 = /** @type {(inputs: Svc_Retainer_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizacje, audyty i raport na koniec każdego miesiąca.`)
};

/**
* | output |
* | --- |
* | "Updates, audits and a report at the end of each month." |
*
* @param {Svc_Retainer_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_harden_detail6 = /** @type {((inputs?: Svc_Retainer_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_retainer_harden_detail6(inputs)
	if (locale === "de") return de_svc_retainer_harden_detail6(inputs)
	if (locale === "es") return es_svc_retainer_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_retainer_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_retainer_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_retainer_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_retainer_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_retainer_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_retainer_harden_detail6(inputs)
	return en_svc_retainer_harden_detail6(inputs)
});
export { svc_retainer_harden_detail6 as "svc_retainer_HARDEN_detail" }